<script>
/**
 * Features component
 */
export default {
  name: 'Features'
};
</script>

<template>
  <!--START FEATURES-->
  <section class="section" id="features">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="features-box mt-5 mt-lg-0">
            <h3>Estamos comprometidos con la transformación digital en todos los ámbitos  que lo requieran</h3>
            <p
              class="text-muted web-desc"
            >Nuestro equipo de ingenieros lo acompañará y lo asesorará en todo momento del proceso de adopción a la nube y/o On Premise, permitiendo  modernizar su infraestructura, desarrollar aplicaciones modernas;  que convivan con sus sistemas actuales, así como establecer una estrategia de modernización que le permita tomar decisiones de forma oportuna.</p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li class>Logramos adoptar tendencias ágiles.</li>
              <li class>Capacitaciones en todos los niveles.</li>
              <li class>Modernizamos sus procesos.</li>
              <li class>Desarrollo Móvil con la mejor calidad.</li>
              <li class>Staffing IT.</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-img mx-auto mr-lg-0">
            <img src="@/assets/images/growth-analytics.svg" alt="macbook image" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--END FEATURES-->
</template>